import { useEffect } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL, WHATSAPP_LINK } from "@/pages/home/constants";

export default function NotFound() {
  useEffect(() => {
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");

    const previousTitle = document.title;
    document.title = "Página não encontrada | Eco Tour Turismo Capitólio";

    return () => {
      robots?.setAttribute("content", "index, follow");
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="min-h-screen bg-background-50 flex flex-col">
      <header className="bg-primary-950">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src={LOGO_URL}
                alt="Eco Tour Turismo — Passeios de Lancha em Capitólio"
                title="Eco Tour Turismo Capitólio"
                className="h-10 md:h-12 w-auto object-contain"
              />
            </Link>
          </div>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-lg">
          <p className="font-heading text-5xl md:text-6xl font-bold text-primary-500 mb-4">404</p>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-primary-900 mb-3 tracking-tight">
            Página não encontrada
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            O link que você acessou não existe ou foi movido. Mas não se preocupe: os passeios de lancha
            em Capitólio continuam te esperando no Lago de Furnas.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line text-base" />
              Voltar ao início
            </Link>
            <a
              href={WHATSAPP_LINK}
              data-whatsapp-cta
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}